import React from 'react'
import { useSelector } from 'react-redux'
import { Container, Row, Col, Badge } from 'react-bootstrap'
import MyCard from '../components/MyCard'

function Favorites(){
    const movies = useSelector(state => state.favorites)
    return (
        <>
            <Container>
                <Row className="justify-content-center mt-3" md={1}>
                    <Badge variant="info" className="pt-2"><h4>Favorites</h4></Badge>
                </Row>
                <Row xs={2} md={3}>
                    {
                        movies.map((movie) => {
                            return (
                                <Col key={movie.id}><MyCard movie={movie}/></Col>
                            )
                        })
                    }
                </Row>
            </Container>

        </>
    )
}

export default Favorites